<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <h4 class="page-title">Research Admins</h4>
      </div>
    </div>
  </div>

  @if (error) {
    <div class="alert alert-danger">{{ error }}</div>
  }

  <div class="card mb-3">
    <div class="card-body">
      <h6 class="card-title">Invite Research Admin</h6>
      <div class="d-flex gap-2 align-items-end">
        <div class="flex-grow-1">
          <input type="email" class="form-control" placeholder="Email address" [(ngModel)]="inviteEmail">
        </div>
        <button class="btn btn-primary" (click)="invite()" [disabled]="inviting || !inviteEmail">
          @if (inviting) { <span class="spinner-border spinner-border-sm me-1"></span> }
          Invite
        </button>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      @if (loading) {
        <div class="text-center py-4"><span class="spinner-border"></span></div>
      } @else {
        <div class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr><th>Name</th><th>Email</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              @for (admin of admins; track admin.id) {
                <tr>
                  <td>{{ admin.user?.person?.first_name }} {{ admin.user?.person?.last_name }}</td>
                  <td>{{ admin.user?.email || '—' }}</td>
                  <td>
                    <span class="badge" [ngClass]="admin.status === 'ACTIVE' ? 'bg-success-subtle text-success' : admin.status === 'INVITED' ? 'bg-warning-subtle text-warning' : 'bg-danger-subtle text-danger'">
                      {{ admin.status }}
                    </span>
                  </td>
                  <td>
                    @if (admin.status === 'ACTIVE' && admin.user?.email !== currentUserEmail) {
                      <button class="btn btn-sm btn-outline-warning" (click)="updateStatus(admin.id, 'SUSPENDED')">Suspend</button>
                    }
                    @if (admin.status === 'SUSPENDED') {
                      <button class="btn btn-sm btn-outline-success me-1" (click)="updateStatus(admin.id, 'ACTIVE')">Activate</button>
                      <button class="btn btn-sm btn-outline-danger" (click)="updateStatus(admin.id, 'REMOVED')">Remove</button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
</div>
